<template>
  <div class="container">
    <div class="header">
      <span class="title">S-LINK | 编程助手</span>
    </div>
  </div>
</template>

<script>

export default {
  name: "s-link",
  data() {
    return {
     
    };
  },
  mounted(){
    this.$notify({
          title: '成功',
          message: 'S-LINK编程助手已运行！',
          type: 'success'
        });
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100vh;
  background-color: rgb(183, 201, 221);

  background-position: center;
  background-repeat: no-repeat;
  background-image: url(https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/static/homepage/loading-web.gif);
  background-size: 30%;

  .header
  {
    width:800px;
    height: 80px;
    line-height: 80px;
    .title
    {
      margin-left: 30px;
      font-size: 20px;
      font-weight: bold;
    }
  }
}
</style>
